import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useLayoutEffect, useRef, useState, type FC } from 'react';
import type { HotlinePageData } from '../../modules/algebra/global';
import DOMPurify from 'dompurify';
import { useLocation, useSearch } from 'react-location';
import { useCreateWebchat } from '../../modules/datastores/useCreateWebchat';
// import Cookies from 'universal-cookie';
import { createLogger } from '../../modules/prelude/logger';
const fileLabel = 'TOSTermsBanner.ts';
const logger = createLogger({
  fileLabel,
});
const TOSHotlineInfo: FC<{ pageData: HotlinePageData; setAdditionalContent: (content: string) => void }> = ({ pageData, setAdditionalContent }) => {
  const { services, emergencyPhNo } = pageData;
  const gridSize = services?.length > 5 ? 5 : services?.length;
  const location = useLocation();
  const query = useSearch();
  const messaging_service_key = query['messaging_service_key'] as string;
  const { mutateAsync: createWebchat, isLoading } = useCreateWebchat();
  // const cookies = new Cookies();
  const redirect = (createChat: string) => {
    window.location.replace(`${process.env.NX_HOTLINES_CHAT_NOW_BASE_URL}/?messaging_service_key=${messaging_service_key}&task_sid=${createChat}`);
  };
  const [maxTitleHeight, setMaxTitleHeight] = useState(0);
  const containerRef = useRef<any>([]);
  const adjustTitleHeights = () => {
    const heights = containerRef.current.map((titleRef: HTMLElement) => titleRef?.offsetHeight || 0);
    const max = Math.max(...heights);

    setMaxTitleHeight(max);
  };

  useLayoutEffect(() => {
    adjustTitleHeights();
  }, [services]);
  const startTalking = async () => {
    try {
      const createChat = await createWebchat({ messaging_service_key });
      // const date = new Date();
      // date.setTime(date.getTime() + 10 * 60 * 1000);
      // cookies.set(`task_sid${messaging_service_key}`, createChat, { path: '/', expires: date });
      redirect(createChat);
    } catch (startChatError) {
      logger.error('Error While Starting Conversation', startChatError);
    }
  };
  return (
    <div className="hotline-connect">
      <div className="w-full pt-12 mb-2 hotline-services">
        <div className={`grid grid-row-${gridSize} lg:grid-cols-${gridSize} md:grid-cols-1  flex w-full lg:m-auto md:w-10/12 md:m-auto`} id="services">
          {services?.map((e, index) => {
            return (
              <div className="relative min-h-100" key={index}>
                <Paper className="px-4 md:px-4 h-full relative shadow-none flex flex-col" elevation={index}>
                  <div
                    style={{
                      minHeight: `${maxTitleHeight}px`,
                    }}
                    ref={(el) => (containerRef.current ? (containerRef.current[index] = el) : el)}
                    className={`flex ${e.icon ? 'justify-start' : 'justify-center'} items-center hotline-connect-header pb-4`}
                  >
                    {e.icon && (
                      <div className=" shrink-0" style={{ flexShrink: 0 }}>
                        <img className=" icon mr-2" src={e.icon} alt="Rainn icon" />
                      </div>
                    )}

                    <Typography variant="h2" className=" relative flex items-end justify-center   text-xl  text-center  text-pc-1 font-bold ">
                      {e?.planTitle}
                    </Typography>
                  </div>
                  <div className="py-6 ">
                    <Typography variant="body1" className="py-6 relative inline" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(e?.content) }}></Typography>
                    {e?.additionalContent && (
                      <a
                        href={`${location.current.pathname}${location.current.searchStr}#add`}
                        onClick={() => setAdditionalContent(e.additionalContent || '')}
                        className="underline font-bold link-text"
                      >
                        {e?.readMoreText || 'Read More'}
                      </a>
                    )}
                  </div>
                  {e?.btnTitle &&
                    (e?.btnLink ? (
                      <a href={e?.btnLink} className="learn-more-btn justify-center">
                        {e?.btnTitle}
                      </a>
                    ) : (
                      <button disabled={isLoading} onClick={startTalking} className="learn-more-btn justify-center">
                        {e?.btnTitle}
                      </button>
                    ))}
                </Paper>
              </div>
            );
          })}
        </div>
      </div>
      <div className="md:px-12 sm:px-0">
        <Paper className="hotline-connect-safety-message" elevation={0}>
          <a href="https://rainn.org/articles/safety-planning" className="text-tc-2">
            <span className="font-bold">Your safety is important.</span> If you are in immediate danger, call {emergencyPhNo}.
          </a>
        </Paper>
      </div>
    </div>
  );
};

export default TOSHotlineInfo;
